import { ContentDelete } from '@fs/zion-icon'
import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, useOverlay, DangerButton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { deletePerson } from '../../../../services/famousHistoricalService'

export default function FamousDeletePersonButton({
  person,
  personFullName,
  removePersonOnDelete,
  ...personDataOverlay
}) {
  const deleteConfirmationOverlay = useOverlay()
  const { t } = useTranslation()

  const confirmBtnOnClick = async () => {
    try {
      await deletePerson(person.id)
      removePersonOnDelete(person)
      deleteConfirmationOverlay.close()
      personDataOverlay.close()
    } catch (err) {
      // Notify admin of error
    }
  }

  return (
    <>
      <DangerButton Icon={ContentDelete} onClick={deleteConfirmationOverlay.handleClick}>
        {t('action.delete', 'Delete')}
      </DangerButton>
      <DialogOverlay
        {...deleteConfirmationOverlay}
        title={t('tools.lists.headings.deleteFamousPerson', 'Delete Famous Person')}
      >
        {t('tools.lists.notifications.deleteDialog', 'Are you sure you want to permanently delete { name }?', {
          name: personFullName,
        })}
        <DialogOverlayFooter>
          <DialogOverlayActions>
            <Button emphasis="high" onClick={confirmBtnOnClick}>
              {t('action.confirm', 'Confirm')}
            </Button>
            <Button emphasis="medium" onClick={deleteConfirmationOverlay.close}>
              {t('action.cancel', 'Cancel')}
            </Button>
          </DialogOverlayActions>
        </DialogOverlayFooter>
      </DialogOverlay>
    </>
  )
}
